import { render, staticRenderFns } from "./exchangeAgree.vue?vue&type=template&id=29b5f09b&scoped=true"
import script from "./exchangeAgree.vue?vue&type=script&lang=js"
export * from "./exchangeAgree.vue?vue&type=script&lang=js"
import style0 from "./exchangeAgree.vue?vue&type=style&index=0&id=29b5f09b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5f09b",
  null
  
)

export default component.exports